import { useState, useEffect } from "react";
import { format } from "date-fns";
import { JournalEntry, JournalEntryType } from "../types/journal";

interface UseJournalEntryStateResult {
    existingEntry: JournalEntry | null;
    isToday: boolean;
}

export function useJournalEntryState(
    entries: JournalEntry[],
    selectedDate: Date,
    activeTab: JournalEntryType
): UseJournalEntryStateResult {
    const [existingEntry, setExistingEntry] = useState<JournalEntry | null>(null);
    const [isToday, setIsToday] = useState<boolean>(false);

    useEffect(() => {
        const selectedDateStr = format(selectedDate, "yyyy-MM-dd");
        const todayStr = format(new Date(), "yyyy-MM-dd");

        setIsToday(selectedDateStr === todayStr);

        const entry = entries.find(
            (entry) =>
                format(entry.date, "yyyy-MM-dd") === selectedDateStr &&
                entry.type === activeTab
        ) || null;

        setExistingEntry(entry);
    }, [entries, selectedDate, activeTab]);

    return { existingEntry, isToday };
}